export const blacklistedWords = ['sportable', 'sp0rtabletech', 'password']

// From FB password policy
// 1 lowercase, uppercase and special character
export const validPasswordSpecialChars = [
  '^',
  '$',
  '*',
  '.',
  '[',
  ']',
  '{',
  '}',
  '(',
  ')',
  '?',
  '"', // Escaped double quote
  '!',
  '@',
  '#',
  '%',
  '&',
  '/',
  '\\', // Escaped backslash
  ',',
  '>',
  '<',
  "'",
  ':',
  ';',
  '|',
  '_',
  '~'
]
export const passwordSpecialCharRegex = new RegExp(
  `.*[\\^\\$\\*\\.\\[\\]\\{\\}\\(\\)\\?\\"\\!\\@\\#\\%\\&\\/\\\\,\\>\\<\\'\\:\\;\\|\\_\\~].*`
)
